/**
 * Single source of truth for the identity query key shape.
 * Keying on the JWT means a new paste automatically triggers a fresh fetch.
 */
export const identityQueryKey = (jwt: string | null) => ["identity", jwt] as const;
